import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { RequestService } from '@app/_services/request.service';
import { authorityIds, operations, subAuthorities } from '@app/enums';

@Injectable({ providedIn: 'root' })
export class EntityApiService {
  constructor(private REQ: RequestService) {}

  getEntityList(): Observable<any> {
    const qry = {
      params: {},
      user_data: {
        authority: authorityIds.ENTITY,
        sub_authority: subAuthorities.ENTITY.LIST,
        operation: operations.LIST,
      },
    };
    return this.REQ.get('entity/list', { query: JSON.stringify(qry) });
  }
}
